import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useEffect } from 'react';
import { useCurationsTree } from '../../hooks/useCurationsTree';
import { useCatalogContext } from '../../state/Catalog';
import { useCurationsIndexHealth } from '@apps/registry/common/components/Catalog/routes/CurationsIndex/CurationsIndex.health';
import { useCatalogLoggingContext } from '../../Catalog.logging';

const usePageTelemetry = () => {
  const { curationDetail: trackCurationDetailPage, getProductCatalogCategoryBasePageEventProps } = useCatalogLoggingContext();

  const trackPage = useEventCallback((action: 'enter') => {
    const categoryPageProps = getProductCatalogCategoryBasePageEventProps({
      product: null,
      curation: null
    }).categoryTelemArgs;

    trackCurationDetailPage[action]?.(categoryPageProps);
  });

  useEffect(() => {
    trackPage('enter');
  }, [trackPage]);
};

export const useCurationsIndexController = () => {
  const { isMobile, selectedCategory } = useCatalogContext();
  const { treeRoot, isLoadingTreeRootData, error } = useCurationsTree();

  const { onLoadComplete, onLoadFailure } = useCurationsIndexHealth();
  useEffect(() => {
    if (error) {
      onLoadFailure('CatalogCurationsTreeRootQuery failed', error);
    } else if (treeRoot) {
      onLoadComplete();
    }
  }, [error, onLoadFailure, treeRoot, onLoadComplete]);

  const curations = treeRoot?.children || [];
  const heroText = treeRoot?.heroText;

  usePageTelemetry();

  return {
    isMobile,
    curations,
    heroText,
    isLoadingTreeRootData,
    showSkeleton: isLoadingTreeRootData && !curations.length,
    selectedCategory
  };
};
